export enum GenderQueryKeys {
  Primary = '/genders',
}
